define(function(require,exports,module){
	var pitchFxDataContainerTemplateClassName = "data-description",
		domHelper = require( '../helpers/domHelper' ),
		vendor = require( 'Responsive/vendor' ),
		imageDensity = require( 'Responsive/util/imageDensity' ),
		imageLoader = require( 'image-loader/image-loader' ),
        Tether = require('tether/dist/js/tether'),
        PitchTypes = require("gameday-index-enums/enums/baseball/PitchTypes"),
        cssClass = require( '../helpers/cssClass' ),
        feetDashInches = require('../math/feetDashInches');

	var regexPlayer = /\w+-(\w+)-(\w+)(@2x)?(\.\w+)/,
		regexLefty = /\s*lefty|$\s*/;

    var STRING = 'string';

    function RenderDom(pitchLayer){
    	this.pitchLayer=pitchLayer;
    	this.scalers=pitchLayer.scalers;

        this.sizer = document.createElement('img');
        this.player = document.createElement('div');
        this.ballTemplate = document.createElement('div');
        this.container = document.createElement('div');
        this.pitchFxDataContainerTemplate = document.createElement('div');
        this.pitchFxDataItemDescriptionTemplate = document.createElement('div');
        this.pitchFxDataItemTemplate = document.createElement('span');

        this.sizer.className = cssClass("aspect-ratio");
        this.container.className = cssClass("dom");
        this.player.className = cssClass("player");
        this.player.setAttribute("data-responsive-pitch-fx-hide",true);
        this.ballTemplate.className = cssClass("ball");
        this.pitchFxDataContainerTemplate.className = cssClass(pitchFxDataContainerTemplateClassName);
        this.pitchFxDataItemDescriptionTemplate.className = cssClass("data-item");
        this.sizer.src = this.getSizerURI();
        this.config = pitchLayer.config;
        // store tether instances
        this.tethers = {};

        // TODO : depth effect blur, for stadium bg
        // this.blur.height = 0;
        // this.blur.innerHTML = '<filter id="fieldBlur">'
        //     + '     <feGaussianBlur stdDeviation="3"/>'
        //     + '</filter>'

    }

    RenderDom.prototype={

        calculateDivBall : function (coord, offset, dim) {
            var coord_per = ((coord - (offset)) / this.pitchLayer.scalers[dim]) * 100;
            return coord_per + '%';
        },
        drawPitch      : function(pitch){
            var sz = pitch.szTop && pitch.szBot ? pitch : this.scalers.strikeZone;
            this.container.setAttribute("data-sz-top",sz.szTop);
            this.container.setAttribute("data-sz-bot",sz.szBot);
        },
        drawStrikeZone : function(pitch){

        },
        drawBall : function(p, pt){
            var that=this,
                scalers=this.scalers,
                fsize = ( scalers.fontSize / this.pitchLayer.scalers.base_width * this.scalers.fakeBallSize).toFixed(2),
                ballEl = this.ballTemplate.cloneNode(),
                font = 'bold ' + fsize + 'em ' + that.config.font,
                ballDiameter = pt[4];

            ballEl.className += " " + cssClass("pitch-" + p.type);

            if(p.ballInDirt) {
                ballEl.className += " " + cssClass("ball-in-dirt");
            }

            ballEl.style.top = this.calculateDivBall(pt[1], ballDiameter, 'height');
            ballEl.style.left = this.calculateDivBall(pt[0], ballDiameter, 'width');
            ballEl.style.height = this.calculateDivBall(ballDiameter, -ballDiameter, 'height');
            ballEl.style.width = this.calculateDivBall(ballDiameter, -ballDiameter, 'width');
            ballEl.style.fontSize = fsize / scalers.canvasDensity + 'em';
            ballEl.style.fontFamily = that.config.font;

            if (p.num) {
                ballEl.setAttribute('data-pitch-num', p.num);
            }

            if (!this.pitchLayer.render.isCanvas || that.config.domBalls) {
                ballEl.style.backgroundColor = p.shader.ball;
                ballEl.style.backgroundSize = "150%";
                //ballEl.style.backgroundImage="radial-gradient(circle farthest-corner, " + color.replace(regexColor, colorShiftLight) +" 0%," + color +" 40%,"+ color.replace(regexColor, colorShift) +" 100%";
                ballEl.style.border = '1px solid ' + p.shader.ballStroke;
                ballEl.style.color = p.shader.text;
                ballEl.innerHTML = p.num || ""; // No number? Just show ball without it
            }

            // Draw Pitch Fx data for when ball is hovered/clicked
            if(that.config.hoverData) {
                function addPitchFxDataLine(label, dataPoint) {
                    var pitchFxDataItem = that.pitchFxDataItemDescriptionTemplate.cloneNode();
                    var pitchFxData = that.pitchFxDataItemTemplate.cloneNode();
                    pitchFxDataItem.innerHTML = "<span class='label'>" + label + "</span><span class='data-point'>" + dataPoint + "</span>" ;
                    pitchFxDataItem.appendChild(pitchFxData);
                    pitchFxDataEl.appendChild(pitchFxDataItem);
                }

                var pitchFxDataEl = this.pitchFxDataContainerTemplate.cloneNode();

                addPitchFxDataLine(p.num , p ? p.result : "");
                addPitchFxDataLine("Type", p ? this.getPitchDisplayName(p) : "--");
                addPitchFxDataLine("Velocity", p.startSpeed ? p.startSpeed + " mph" : '--');
                addPitchFxDataLine("Spin Rate ", (p.spinRate == 0 || !p.spinRate ? "--" : p.spinRate + " rpm"));
                addPitchFxDataLine("Break ", (p.breaks == 0 || !p.breaks ? "--" : p.breaks + " deg"));

                if (p.num) {
                    pitchFxDataEl.className = pitchFxDataEl.className + " " + cssClass("pitch-" + p.num);
                }

                ballEl.addEventListener('mouseenter', function (pitchDiv) {
                    var pitchNumber = pitchDiv.currentTarget.getAttribute('data-pitch-num');
                    var pitchData = document.querySelector('.'+cssClass("pitch-") + pitchNumber);
                    pitchData.style.visibility = 'visible';
                    pitchData.style.opacity = 1;
                    pitchData.style.zIndex = '9999';
                    // tracking.track_pitches_activity();
                });

                // Hide pitch data when your mouse leaves the divBall
                ballEl.addEventListener('mouseleave', function (pitchDiv) {
                    var pitchNumber = pitchDiv.currentTarget.getAttribute('data-pitch-num');
                    var pitchData = document.querySelector('.'+cssClass("pitch-") + pitchNumber);
                    pitchData.style.visibility = null;
                    pitchData.style.opacity = null;
                    pitchData.style.zIndex = null;
                });
                domHelper.append(ballEl,pitchFxDataEl);

                // cache selected card views
                var leftCard = document.querySelector('.CardView-left');
                var rightCard = document.querySelector('.CardView-right');

                /*
                 * Compute visible area between left/right scroll cards for each pitch. This way 'Tether' knows
                 * when the hover pitch fx div is out of view and adjusts its orientation accordingly
                 * (The contraints are set in constraints[{to}] - X1, Y1, X2, Y2).
                 * If left/right cards aren't available, use the pitchView bounding rect
                 */
                var leftCardCoords = leftCard && leftCard.getBoundingClientRect();
                var rightCardCoords = rightCard && rightCard.getBoundingClientRect();
                var pitchViewCoords = this.pitchLayer.view.getBoundingClientRect();

                // Build bounds differently if you're using the pitchView vs the pull cards.
                var hoverDataBounds = {
                    x1: leftCardCoords ? leftCardCoords.right : pitchViewCoords.left,
                    y1: leftCardCoords ? leftCardCoords.top : pitchViewCoords.top,
                    x2: rightCardCoords ? rightCardCoords.left : pitchViewCoords.right,
                    y2: rightCardCoords ? rightCardCoords.bottom : pitchViewCoords.bottom,
                };

                setTimeout(function() {

                    if(that.tethers[p.num]){
                        that.destroyPitchHover(that.tethers[p.num]);
                    }
                    if (that.container && that.container.parentNode) {
                        var rootNode = that.container.getRootNode();
                        var bodyElement = document.body;
                        if (rootNode !== document) {
                            bodyElement = rootNode
                        }

                        // Confirm that this ball is still relevant
                        // and has been attached to container - otherwise
                        // we might be in a clean-up phase.
                        if (ballEl && ballEl.parentNode) {
                            var tether = new Tether({
                                element: pitchFxDataEl,
                                target: ballEl,
                                attachment: 'bottom center',
                                targetAttachment: 'top center',
                                offset: '12px 0',
                                bodyElement: bodyElement,
                                constraints: [
                                    {
                                        to: [hoverDataBounds.x1, hoverDataBounds.y1, hoverDataBounds.x2, hoverDataBounds.y2],
                                        attachment: 'together',
                                        pin: true
                                    }
                                ]
                            });

                            that.tethers[p.num] = tether;

                            tether.position()
                        }
                    }
                }, 100);
            }

            domHelper.append(this.container,ballEl);

        },
        // TODO: There's some clean up that's possible here
        drawBatter: function () {
            var currentTeamUniform = this.pitchLayer.atbat.uniformData || {};
            var { jersey, pants } = currentTeamUniform;
            
            this.loadBatterImageWithFallbacks(jersey, pants, currentTeamUniform.fullSet);
        },
        
        loadBatterImageWithFallbacks: function(jersey, pants, fullSet) {
            var that = this;
            
            // Try fullset if available
            if (fullSet && fullSet !== 'fallback') {
                this.tryLoadUniformSet(jersey, pants)
                    .catch(function() { 
                        return that.tryLoadTeamFallback();
                    })
                    .catch(function() { 
                        that.loadGenericFallback();
                    });
            } else {
                // Skip to team fallback if no fullset
                this.tryLoadTeamFallback()
                    .catch(function() { 
                        that.loadGenericFallback();
                    });
            }
        },

        tryLoadUniformSet: function(jersey, pants) {
            var that = this;
            var batterSrc = this.pitchLayer.atbat.getBatterImage({ jersey: jersey, pants: pants });
            var jerseyPromise = imageLoader.load(batterSrc.jerseySrc);
            var pantsPromise = imageLoader.load(batterSrc.pantsSrc);
        
            return Promise.all([jerseyPromise, pantsPromise])
                .then(function(results) {
                    var jerseySrc = results[0].src;
                    var pantsSrc = results[1].src;
                    that.setPlayerImage({jersey: jerseySrc, pants: pantsSrc});
                });
        },
        
        tryLoadTeamFallback: function() {
            var that = this;
            var batterImage = this.pitchLayer.atbat.getBatterImage({
                jersey: null,
                pants: null,
                isGeneric: true
            });
            
            var uniform = (typeof batterImage === STRING) 
                ? batterImage
                : (batterImage && batterImage.uniform);
        
            if (!uniform) {
                return Promise.reject(new Error('No team fallback available'));
            }
        
            return imageLoader.load(uniform)
                .then(function(result) {
                    that.setPlayerImage({
                        jersey: null,
                        pants: null,
                        genericSrc: result.src,
                        isGeneric: true
                    });
                });
        },
        
        loadGenericFallback: function() {
            var that = this;
            var batterImage = this.pitchLayer.atbat.getBatterImage({
                jersey: null,
                pants: null,
                isGeneric: true,
                forceGeneric: true
            });
            
            var uniform = (typeof batterImage === STRING)
                ? batterImage
                : (batterImage && batterImage.uniform);
        
            that.setPlayerImage({
                jersey: null,
                pants: null,
                genericSrc: uniform,
                isGeneric: true
            });
        },

            parseBatterHeight : function(height) {
                var b_height=((height || this.scalers.batterHeight)+"").split('-'),
				feet = parseFloat(b_height[0]) + (parseFloat(b_height[1])/ 12);
                return feet;
            },

            setPlayerImage: function ({jersey, pants, genericSrc = '', isGeneric = false}) {
                var that = this,
            	scalers = this.scalers,
            	parent = this.pitchLayer.view,
            	isRighty = this.pitchLayer.atbat.stand !== "L",
                atbat = this.pitchLayer.atbat,
                rawHeight = atbat.batter && atbat.batter.person && atbat.batter.person.height || atbat.height || atbat.batterHeight,
                bHeight = scalers.batterScaling && rawHeight && (feetDashInches(rawHeight) / scalers.batterHeight).toFixed(4) || 1.0;

                this.player.setAttribute("data-responsive-pitch-fx-hide",true);
                this.player.setAttribute("data-player-height", rawHeight);

                //300ms delay to allow for the fade to occur
                setTimeout(function () {
                    if (parent) {
                        parent.className = parent.className.replace(regexLefty, isRighty ? '' : ' lefty');
                    }
                    that.player.style.width = scalers.batterX + '%';
                    // that.player.style.height = scalers.batterY + '%';
                    that.player.style.top = 51 - scalers.batterTop + '%';
                    if (isRighty) {
                        that.player.style.right = '';
                        that.player.style.left = 49 - scalers.batterLR + '%';
                    } else {
                        that.player.style.left = '';
                        that.player.style.right = 49 - scalers.batterLR + '%';
                    }
                    if (isGeneric) {
                    that.player.style.backgroundImage = "url(" + genericSrc + ")";
                } else {
                    that.player.style.backgroundImage = "url(" + jersey + "), url(" + pants + ")";
                }
                that.player.style[vendor.transformJS] = "scale(" + bHeight + ")";

                that.player.setAttribute("data-responsive-pitch-fx-hide",false);

            }, 300);
        },
        removePlayerImage : function () {
            // hide image, for whatever reason (no atbat present, pitching sub, etc)
            this.player.setAttribute("data-responsive-pitch-fx-hide",true);
        },
        getPitchDisplayName: function (p) {
            return  p.pitch.details &&
                    p.pitch.details.type &&
                    PitchTypes[p.pitch.details.type] ||
                    p.displayName ||
                    "--";
        },
        resize : function(){

        },

        clear : function(){
            var tethers = this.tethers,
                tether;
            this.container.setAttribute("data-responsive-pitch-fx-hide",true)
            this.container.innerHTML="";

            this.removePlayerImage();
            for(tether in tethers){
                this.destroyPitchHover(tethers[tether]);
                delete tethers[tether]
            }
            this.container.setAttribute("data-responsive-pitch-fx-hide",false)
        },
        getSizerURI: function (h,w) {
            if(!this.pitchLayer.render){
                return require('../enums/16x11');
            }
            return this.pitchLayer.render.getSizerURI();
        },
    	anchor	: function(){
            domHelper.append(this.pitchLayer.view,this.sizer);
    		domHelper.append(this.pitchLayer.view,this.player);
    		domHelper.append(this.pitchLayer.view,this.container);
    	},
        destroy : function(){
        	this.clear();

	        domHelper.remove(this.player);
	        domHelper.remove(this.container);
            domHelper.remove(this.sizer);
        },
        destroyPitchHover : function(hoverObject){
            hoverObject.destroy();
            // Tether doesn't remove absolutely positioned element from DOM on destroy().
            domHelper.remove(hoverObject.element);
        }
    };

    return RenderDom;
});
